import { render, staticRenderFns } from "./state.vue?vue&type=template&id=38b0ce49&"
import script from "./state.vue?vue&type=script&lang=js&"
export * from "./state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports